export const ACCOUNT_LOCKED_ERROR = 'account_locked';
// The code step found no pending sign-in, so the password step takes over
export const CHALLENGE_EXPIRED_MESSAGE =
  'Your sign-in expired. Enter your password again to get a new code.';
export const EMAIL_VERIFICATION_REQUIRED_ERROR = 'email_verification_required';
export const GENERIC_ERROR_MESSAGE =
  'Yikes! Something went wrong when trying to log in. If you keep having trouble, please contact support.';
export const MFA_ERROR = 'mfa_required';
export const NEW_DEVICE_CONFIRMATION_REQUIRED_ERROR =
  'new_device_confirmation_required';
// Seconds before a sign-in code can be re-sent, when the backend doesn't say
export const NEW_DEVICE_RESEND_COOLDOWN_SECONDS = 60;
export const PENDING_WORKSPACE_ACCESS_ERROR = 'pending_workspace_access';
export const DASHBOARD_FALLBACK_URL_NAME = 'dashboard';
